import { CfgCondition, ElementAttachPointPosition } from './catalog-types'

export type OptionValues = Record<string, string | null>

export const MAIN_SCENE = 'main';

export interface ElementInstance {
    id: string
    element: string
    attachedTo?: {
        otherId: string
        otherPosition: ElementAttachPointPosition
        ownPosition: ElementAttachPointPosition
    }
}

export interface GroupItem {
    id: string
    options: OptionValues
    elements: ElementInstance[]
    position: [ number, number, number ]
    rotation: number
    showIf?: CfgCondition
    scene: string
    initial?: boolean
    counters?: Record<string,number>
}

export interface Composition {
    groups: GroupItem[]
}


// ==== Work types (add, etc) ====

export type ElementInstanceAdd = Omit<ElementInstance, 'id'>;
